import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { TextDesktop } from '@alfa-bank/site-text-v2/desktop';

import styles from './styles/checkbox.css';
import type { TCheckbox, ICheckboxDeps } from './models';
import { Checkbox as Component } from './checkbox';

export const WrappedCheckboxDesktop = createWidget<ICheckboxDeps, TCheckbox>({
    styles,
    Text: TextDesktop,
})(Component);
